package org.hs_soft.runmynesto.domain.usecase.product.tab_restaurant

import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.delete_addition.DeleteAdditionModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_restaurant.DeleteProductAdditionRepository

class DeleteProductAdditionUseCase(
    private val repository: DeleteProductAdditionRepository
) {
    suspend operator fun invoke(id:String): DeleteAdditionModel {
        return repository.deleteProductAddition(id)
    }
    fun cancel(){
        repository.cancel()
    }
}